import { render, staticRenderFns } from "./LogsLayout.vue?vue&type=template&id=412b057a&scoped=true&"
import script from "./LogsLayout.vue?vue&type=script&lang=js&"
export * from "./LogsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b057a",
  null
  
)

export default component.exports